import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_STATE } from "../initialState";
export const gameSlice = createSlice({
  name: "gameData",
  initialState: INITIAL_STATE,
  reducers: {
    setSideBarData: (state, action) => {
      state.sideBarData = { ...state.sideBarData, ...action.payload };
    },
    setCricketOdds: (state, action) => {
      Object.assign(state.cricketOdds, action.payload);
    },
    setTennisOdds: (state, action) => {
      Object.assign(state.tennisOdds, action.payload);
    },
    setSoccerOdds: (state, action) => {
      Object.assign(state.soccerOdds, action.payload);
    },
    setTennisGames: (state, action) => {
      state.tennisGames = action.payload;
    },
    setCricketGames: (state, action) => {
      state.cricketGames = action.payload;
    },
    setSoccerGames: (state, action) => {
      state.soccerGames = action.payload;
    },
    mergeCricketGames: (state, action) => {
      const liveData = action.payload || [];
      if (!state.cricketGames || state.cricketGames.length === 0) {
        state.cricketGames = liveData;
        return;
      }
      const liveMap = {};
      liveData.forEach((item) => { if (item.cricketId) liveMap[item.cricketId] = item; });
      state.cricketGames = state.cricketGames.map((existing) => {
        const updated = liveMap[existing.cricketId];
        if (updated) {
          delete liveMap[existing.cricketId];
          return { ...existing, ...updated };
        }
        return existing;
      });
      Object.values(liveMap).forEach((item) => state.cricketGames.push(item));
    },
    mergeSoccerGames: (state, action) => {
      const liveData = action.payload || [];
      if (!state.soccerGames || state.soccerGames.length === 0) {
        state.soccerGames = liveData;
        return;
      }
      const liveMap = {};
      liveData.forEach((item) => { if (item.soccerId) liveMap[item.soccerId] = item; });
      state.soccerGames = state.soccerGames.map((existing) => {
        const updated = liveMap[existing.soccerId];
        if (updated) {
          delete liveMap[existing.soccerId];
          return { ...existing, ...updated };
        }
        return existing;
      });
      Object.values(liveMap).forEach((item) => state.soccerGames.push(item));
    },
    mergeTennisGames: (state, action) => {
      const liveData = action.payload || [];
      if (!state.tennisGames || state.tennisGames.length === 0) {
        state.tennisGames = liveData;
        return;
      }
      const liveMap = {};
      liveData.forEach((item) => { if (item.tennisId) liveMap[item.tennisId] = item; });
      state.tennisGames = state.tennisGames.map((existing) => {
        const updated = liveMap[existing.tennisId];
        if (updated) {
          delete liveMap[existing.tennisId];
          return { ...existing, ...updated };
        }
        return existing;
      });
      Object.values(liveMap).forEach((item) => state.tennisGames.push(item));
    },
    setSelectedEventForBet: (state, action) => {
      if (action.payload === null) {
        state.selectedEventForBet = null;
      } else {
        state.selectedEventForBet = {
          ...state.selectedEventForBet,
          ...action.payload,
        };
      }
    },
    setCasinoOdds: (state, action) => {
      state.casinoOdds = action.payload;
    },
    setMatchSettings: (state, action) => {
      let { game, settings, eventId } = action.payload;
      if (game === "cricket") {
        state.cricketSettings[eventId] = settings;
      }
      if (game === "tennis") {
        state.tennisSettings[eventId] = settings;
      }
      if (game === "soccer") {
        state.soccerSettings[eventId] = settings;
      }
    },
    setTeenOdds: (state, action) => {
      state.teenOdds = action.payload;
    },
    setTeenPatti20Odds: (state, action) => {
      state.teenPatti20Odds = action.payload;
    },
    setLucky7Odds: (state, action) => {
      state.lucky7Odds = action.payload;
    },
    setLucky7euOdds: (state, action) => {
      state.lucky7euOdds = action.payload;
    },
    setCard32Odds: (state, action) => {
      state.card32Odds = action.payload;
    },
    setAndarBahar20Odds: (state, action) => {
      state.andarBahar20Odds = action.payload;
    },
    setPoker20Odds: (state, action) => {
      state.poker20Odds = action.payload;
    },
    setDragonTiger20Odds: (state, action) => {
      state.dragonTiger20Odds = action.payload;
    },
    setDragonTiger202Odds: (state, action) => {
      state.dragonTiger202Odds = action.payload;
    },
    setCasinoQueenOdds: (state, action) => {
      state.casinoQueenOdds = action.payload;
    },
    setDragonTigerLionOdds: (state, action) => {
      state.dragonTigerLionOdds = action.payload;
    },
    setTeen8Odds: (state, action) => {
      let payload = action.payload;
      if (payload.cards) {
        for (let i = 0; i < payload.cards.length; i++) {
          if (payload.cards[i].length < 3) {
            while (payload.cards[i].length < 3) {
              payload.cards[i].push("1");
            }
          }
        }
      }
      state.teen8Odds = payload;
    },
    setTeen9Odds: (state, action) => {
      state.teen9Odds = action.payload;
    },
    setCasinoMeterOdds: (state, action) => {
      state.casinoMeterOdds = action.payload;
    },
    setPoker9Odds: (state, action) => {
      state.poker9Odds = action.payload;
    },

    setCard32euOdds: (state, action) => {
      state.card32euOdds = action.payload;
    },
    setRace20Odds: (state, action) => {
      state.race20Odds = action.payload;
    },
    setWorli2Odds: (state, action) => {
      state.worli2Odds = action.payload;
    },
    setBollywoodTableOdds: (state, action) => {
      state.bollywoodTableOdds = action.payload;
    },
    setCasinoWarOdds: (state, action) => {
      state.casinoWarOdds = action.payload;
    },
    setAbjOdds: (state, action) => {
      state.abjOdds = action.payload;
    },
    setBaccarat20Odds: (state, action) => {
      state.baccarat2Odds = action.payload;
    },
    setBaccaratOdds: (state, action) => {
      state.baccaratOdds = action.payload;
    },
    setCmatch20Odds: (state, action) => {
      state.cmatch20Odds = action.payload;
    },
    setWorliOdds: (state, action) => {
      state.worliOdds = action.payload;
    },
    setTeen62Odds: (state, action) => {
      state.teen62Odds = action.payload;
    },
    setDolidanaOdds: (state, action) => {
      state.dolidanaOdds = action.payload;
    },
    setMogamboOdds: (state, action) => {
      state.mogamboOdds = action.payload;
    },
    setLucky5Odds: (state, action) => {
      state.lucky5Odds = action.payload;
    },
    setRoulette12Odds: (state, action) => {
      state.roulette12Odds = action.payload;
    },
    setRoulette13Odds: (state, action) => {
      state.roulette13Odds = action.payload;
    },
    setRoulette11Odds: (state, action) => {
      state.roulette11Odds = action.payload;
    },
    setPoisonOdds: (state, action) => {
      state.poisonOdds = action.payload;
    },
    setPoison20Odds: (state, action) => {
      state.poison20Odds = action.payload;
    },
    setJoker120Odds: (state, action) => {
      state.joker120Odds = action.payload;
    },
    setJoker20Odds: (state, action) => {
      state.joker20Odds = action.payload;
    },
    setJoker1Odds: (state, action) => {
      state.joker1Odds = action.payload;
    },
    setTeen20cOdds: (state, action) => {
      state.teen20cOdds = action.payload;
    },
    setBtable2Odds: (state, action) => {
      state.btable2Odds = action.payload;
    },
    setTeenUniqueOdds: (state, action) => {
      state.teenUniqueOdds = action.payload;
    },
    setOurRouletteOdds: (state, action) => {
      state.ourRouletteOdds = action.payload;
    },
    setCricketv3Odds: (state, action) => {
      state.cricketv3Odds = action.payload;
    },
    setAaaOdds: (state, action) => {
      state.aaaOdds = action.payload;
    },
    setDragonTigerOneDayOdds: (state, action) => {
      state.dragonTigerOneDayOdds = action.payload;
    },
    setSuperOverOdds: (state, action) => {
      state.superOverOdds = action.payload;
    },
    setSuperOver3Odds: (state, action) => {
      state.superOver3Odds = action.payload;
    },
    setGoalOdds: (state, action) => {
      state.goalOdds = action.payload;
    },
    setAb4Odds: (state, action) => {
      state.ab4Odds = action.payload;
    },
    setLucky15Odds: (state, action) => {
      state.lucky15Odds = action.payload;
    },
    setIsDataLoaded(state, action) {
      state.isDataLoaded = action.payload;
    },

    logOut: (state, action) => {
      state.selectedEventForBet = null;
      state.isDataLoaded = false;
      state.cricketGames = null;
      state.soccerGames = null;
      state.tennisGames = null;
    },
  },
});

//export const { increment, decrement, incrementByAmount, spin } = game.actions;
export default gameSlice.reducer;
